import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function ConsentBannerLoadingKr() {
  const {t} = useInferableTranslation();
  return (
    <div className="guide_banner skeleton">
      <p className="guide_banner_desc">{t('T20205')}</p>
      <button
        type="button"
        className="btn_hyperlink"
      >
        {t('T20206')}
      </button>
    </div>
  );
}

export default ConsentBannerLoadingKr;
